export class WorkflowCollections {
  static ModuleName = 'starlink';

  static Workflows = `${WorkflowCollections.ModuleName}/workflows`;
  static workflow(workflowId: string) {
    return `${WorkflowCollections.Workflows}/${workflowId}`;
  }
}
